import React, { FC, Suspense } from 'react';

import type { Me } from '@crehana/web/dist/ReactContexts/AuthContext';
import SimpleCourseCard, {
  SimpleCourseCardSkeleton,
} from '@crehana/web/dist/components/Cards/SimpleCourseCard';
import { Col, Row, Container } from '@crehana/ui';
import parseCourseFragment from '@crehana/web/dist/Graphql/Parsers/parseCourseFragment';
import styled from 'styled-components';

import StructuredDataCourseList from 'Shared/SEO/StructuredData/CourseList';

import { CATALOG_AMPLITUDE_PAGE_NAME } from 'Jsx/Catalog/constants';
import { CoursesFragment } from 'Jsx/Shared/CourseCardV3/graphql/types/CoursesFragment';
import { CourseRecommendedFragment } from 'Jsx/Shared/CourseCardV3/graphql/types/CourseRecommendedFragment';

import { COMMON_COLS } from './constants';

const PremiumVisualRest = React.lazy(
  () => import('../VisualRest/PremiumVisualRest'),
);

const SimpleCourseCardStyled = styled(SimpleCourseCard)`
  & .watch-trailer > button > {
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: 0px !important;
  }
`

interface CourseListProps {
  loading?: boolean;
  skeletonItems?: number;
  courses: (CoursesFragment | CourseRecommendedFragment)[];
  user?: Me;
  showVisualRest: boolean;
}

const CourseListPremium: FC<CourseListProps> = ({
  loading,
  courses,
  skeletonItems = 0,
  user,
  showVisualRest,
}) => {
  return (
    <>
      {/* @ts-expect-error */}
      <StructuredDataCourseList courses={courses} />

      <Container className="w-full lg:mb-32" full>
        <Row>
          {loading
            ? Array.from(Array(skeletonItems)).map((_, i) => (
                <Col
                  key={i.toString()}
                  xs={COMMON_COLS.xs}
                  sm={COMMON_COLS.sm}
                  md={COMMON_COLS.md}
                  lg={COMMON_COLS.lg}
                >
                  <SimpleCourseCardSkeleton />
                </Col>
              ))
            : courses.map((c, index) => {
                const showHereVisualRest =
                  showVisualRest && index !== 0 && index % 8 === 0;

                return [
                  <Col
                    key={c.originalId}
                    xs={COMMON_COLS.xs}
                    sm={COMMON_COLS.sm}
                    md={COMMON_COLS.md}
                    lg={COMMON_COLS.lg}
                  >
                    <SimpleCourseCardStyled
                      source={CATALOG_AMPLITUDE_PAGE_NAME}
                      // @ts-expect-error
                      course={parseCourseFragment(c)}
                      shouldTrackSOFEMembership={!!user?.isSofeMembership}
                      SOFEEnrollmentSource="Catalog Page"
                    />
                  </Col>,
                  showHereVisualRest && (
                    <Col
                      key={'visual_rest_'.concat(index.toString())}
                      totalCols={12}
                    >
                      <Suspense fallback={<div style={{ height: 280 }} />}>
                        <PremiumVisualRest />
                      </Suspense>
                    </Col>
                  ),
                ];
              })}
        </Row>
      </Container>
    </>
  );
};

export default CourseListPremium;
